import { cn } from '@/utils/cn';
import {
  flipkartPercentChange,
  formatFlipkartSynopsisDelta,
  formatFlipkartSynopsisMetric,
  type FlipkartSynopsisMetricFormat,
} from '@/components/flipkart/flipkartSynopsisMetrics';

export function FlipkartSynopsisMetricValue({
  current,
  previous,
  hasPrevious,
  format,
  align = 'end',
  emphasize = false,
}: {
  current: number | null;
  previous: number | null;
  hasPrevious: boolean;
  format: FlipkartSynopsisMetricFormat;
  align?: 'start' | 'end';
  emphasize?: boolean;
}) {
  const delta = hasPrevious ? formatFlipkartSynopsisDelta(flipkartPercentChange(current, previous)) : null;
  return (
    <div className={cn('flex flex-col gap-0.5', align === 'end' ? 'items-end' : 'items-start')}>
      <span className={cn('tabular-nums text-foreground', emphasize && 'font-semibold')}>
        {formatFlipkartSynopsisMetric(current, format)}
      </span>
      {hasPrevious ? (
        <span className="tabular-nums text-body-sm text-foreground-muted">
          {formatFlipkartSynopsisMetric(previous, format)}
        </span>
      ) : null}
      {delta ? (
        <span
          className={cn(
            'tabular-nums text-body-sm',
            delta.direction === 'up' && 'text-emerald-600',
            delta.direction === 'down' && 'text-red-600',
            delta.direction === 'flat' && 'text-foreground-muted'
          )}
        >
          {delta.text}
        </span>
      ) : null}
    </div>
  );
}
